// filepath: /Users/himanshumewari/Projects/NOC-Frontend/noc-frontend/src/gis/src/components/constant.ts
export const INDIAN_STATE_CODES = [
  { label: "Andhra Pradesh", short: "AP" },
  { label: "Arunachal Pradesh", short: "AR" },
  { label: "Assam", short: "AS" },
  { label: "Bihar", short: "BR" },
  { label: "Chhattisgarh", short: "CT" },
  { label: "Goa", short: "GA" },
  { label: "Gujarat", short: "GJ" },
  { label: "Haryana", short: "HR" },
  { label: "Himachal Pradesh", short: "HP" },
  { label: "Jharkhand", short: "JH" },
  { label: "Karnataka", short: "KA" },
  { label: "Kerala", short: "KL" },
  { label: "Madhya Pradesh", short: "MP" },
  { label: "Maharashtra", short: "MH" },
  { label: "Manipur", short: "MN" },
  { label: "Meghalaya", short: "MG" },
  { label: "Mizoram", short: "MZ" },
  { label: "Nagaland", short: "NG" },
  { label: "Odisha", short: "OD" },
  { label: "Punjab", short: "PB" },
  { label: "Rajasthan", short: "RJ" },
  { label: "Sikkim", short: "SK" },
  { label: "Tamil Nadu", short: "TN" },
  { label: "Telangana", short: "TG" },
  { label: "Tripura", short: "TP" },
  { label: "Uttar Pradesh", short: "UP" },
  { label: "Uttarakhand", short: "UK" },
  { label: "West Bengal", short: "WB" },
  { label: "Delhi", short: "DL" },
  { label: "Jammu and Kashmir", short: "JK" },
  { label: "Ladakh", short: "LA" },
  { label: "Puducherry", short: "PY" },
  { label: "Chandigarh", short: "CH" },
  { label: "Andaman and Nicobar Islands", short: "AN" },
  { label: "ANDAMAN & NICOBAR", short: "AN" },
  { label: "Lakshadweep", short: "LD" },
  { label: "Gujarat, Daman and Diu and Dadra and Nagar Haveli", short: "GJ" },
  { label: "DADRA & NAGAR HAVELI & DAMAN & DIU", short: "DN" },
  { label: "Dadar Nagar Haveli", short: "DH" },
];


